import React from "react";

type EllipsisProps = {
  className?: string;
};

const Ellipsis = ({ className }: EllipsisProps) => {
  return (
    <svg
      className={`${className}`}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.3333 10.8889C25.0516 10.8889 26.4444 12.2818 26.4444 14C26.4444 15.7182 25.0516 17.1111 23.3333 17.1111C21.6151 17.1111 20.2222 15.7182 20.2222 14C20.2222 12.2818 21.6151 10.8889 23.3333 10.8889ZM14 10.8889C15.7182 10.8889 17.1111 12.2818 17.1111 14C17.1111 15.7182 15.7182 17.1111 14 17.1111C12.2818 17.1111 10.8889 15.7182 10.8889 14C10.8889 12.2818 12.2818 10.8889 14 10.8889ZM4.66667 10.8889C6.38489 10.8889 7.77778 12.2818 7.77778 14C7.77778 15.7182 6.38489 17.1111 4.66667 17.1111C2.94845 17.1111 1.55556 15.7182 1.55556 14C1.55556 12.2818 2.94845 10.8889 4.66667 10.8889Z"
      />
    </svg>
  );
};

export default Ellipsis;
